/**
 * Created by koppany.kiss on 2017. 09. 27..
 */

export default function (app) {
	app.directive('ngPrint', function () {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				function printElement(elem) {
					var domClone = elem.cloneNode(true);

					var win = window.open();
					self.focus();
					win.document.open();

					win.document.write(domClone);
					win.document.close();
					win.print();
					win.close();
				}

				element.on('click', function () {
					var elemToPrint = document.getElementById(attrs.printElementId);
					if (elemToPrint) {
						printElement(elemToPrint);
					}
				});
				window.onafterprint = function () {
					// clean the print section before adding new content
					printSection.innerHTML = '';
				}
			}
		};
	});
};
